import type { ProductList } from 'src/app/shared/hooks/useProductSetFromCart';
import type { Cart } from 'src/graphql/generated';

type AdProductReturn<K> = Extract<ProductList['items'][0], { __typename: K }>;

export const getAdProductFromCart = <
  T extends ProductList['items'][0]['__typename'],
>(
  cartItems: Cart['items'],
  productSet: ProductList['items'],
  type: T,
): AdProductReturn<T>[] => {
  const cartProductIds = cartItems.map((item) => item.product.id);
  const productSetProducts = productSet || [];
  return productSetProducts.filter(
    (product): product is AdProductReturn<T> =>
      product.__typename === type && cartProductIds.includes(product.id),
  );
};
